import { render, staticRenderFns } from "./shareLink.vue?vue&type=template&id=a68780a6&scoped=true"
import script from "./shareLink.vue?vue&type=script&lang=js"
export * from "./shareLink.vue?vue&type=script&lang=js"
import style0 from "./shareLink.vue?vue&type=style&index=0&id=a68780a6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a68780a6",
  null
  
)

export default component.exports